
const features = [
  {
    name: "USDi",
    description:
      "A decentralised synethic dollar token on Injective, governed by the INJERA token, $ERA. $USDi is created via delta neutral postions, guaranteeing stable yields of 10-90% to USDi holders.",
    href: "#",
    icon: "/images/icons/usdi.svg",
  },
  {
    name: "INJERA Money Market",
    description:
      "Built as a collateralized debt position market, the INJERA money market optimises capital efficiency of USDi by allowing users to leverage USDi to borrow money making assets to create more delta neutral positions.",
    href: "#",
    icon: "/images/icons/money-market.svg",
  },
  {
    name: "Community-first Tokenomics",
    description:
      "At least 55% of $ERA is allocated to the community via airdrops and liquidity mining. 10% is allocated to ecosystem development to encourage builders to innovate and expand the INJERA domain. Final tokenomics pending.",
    href: "#",
    icon: "/images/icons/community.svg",
  },
];

export default function Features() {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-20">
      <div className="mx-auto max-w-2xl lg:text-center">
        <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
          A Highly Capital Efficient Synthetic Dollar, Powered by a CDP Money
          Market
        </p>
        <p className="mt-6 text-lg leading-8 text-gray-300">
          Built to service all of the Cosmos-verse, and Ethereum Virtual Machines (EVM)
        </p>
      </div>
      <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
        <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
          {features.map((feature) => (
            <div key={feature.name} className="flex flex-col">
              <dt className="flex items-center gap-x-3 text-base font-semibold leading-7 text-white">
                <img
                  className="h-5 w-5 flex-none text-cyan-400"
                  src={feature.icon}
                  alt={feature.name}
                  aria-hidden="true"
                />
                {feature.name}
              </dt>
              <dd className="mt-4 flex flex-auto flex-col text-base leading-7 text-gray-300">
                <p className="flex-auto">{feature.description}</p>
                {/* <p className="mt-6">
                  <a
                    href={feature.href}
                    className="text-sm font-semibold leading-6 text-cyan-400">
                    Learn more <span aria-hidden="true">→</span>
                  </a>
                </p> */}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
